import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';

function mapDispatchToProps(dispatch) {
  agent.Artists.all(dispatch);

  return {
  }
}

const mapStateToProps = state => ({
  ...state.artists,
  ...state.mediums
});

/*let artistList = null;
let currArtist = 0;

const callImage = imagePath => {
  return fetch('https://us-central1-mullenlowe-85e8b.cloudfunctions.net/generateThumbnails', { method: 'POST', mode: 'no-cors', body: JSON.stringify({imagePath: imagePath}) });
};

const getArtistImages = images => {
  return new Promise(resolve => {
    let currImage = 0;
    const callImages = (imageNum, images) => {
      if(imageNum < images.length) {
        callImage(images[imageNum].fullPath).then(() => {
          currImage++;
          callImages(currImage, images);
        });
      } else {
        resolve();
      }
    };

    callImages(currImage, images);
  });
}

const callArtist = (artistNum, artists) => {
  if(artistNum < artists.length) {
    if(artists[artistNum].hasOwnProperty("images")) {
      getArtistImages(
        artists[artistNum].images
      ).then(() => {
        currArtist++;
        callArtist(currArtist, artists);
      });
    } else {
      currArtist++;
      callArtist(currArtist, artists);
    }
  }
};*/

const callThumb = () => {
  console.log("Sending: " + missingThumbCount);
  const data =  new FormData();
  data.append('filename', missingThumbs[missingThumbCount]);
  var headers = new Headers();
  headers.append('Accept', 'application/json'); // This one is enough for GET requests
  headers.append('Content-Type', 'application/x-www-form-urlencoded'); // This one sends body

  fetch('http://localhost:8088/generateThumbnail', {headers: headers, mode: 'no-cors', method: 'POST', body: 'filename='+missingThumbs[missingThumbCount]})
    .then(response => {
      missingThumbCount++;

      if(missingThumbCount != missingThumbs.length) {
        //clearInterval(thumbInterval);
        //callThumb();
      }
    });
}

let thumbInterval;
let missingThumbCount = 0;
let missingThumbs = [];

class Utility extends React.Component {



  shouldComponentUpdate(nextProps, nextState) {
    /*var originals = [];
    var thumbs = [];

    fetch('originals.txt')
      .then(response => response.text())
      .then(text => {
        originals = text.split("\n");
        return fetch('thumbs.txt');
      })
      .then(response => response.text())
      .then(text => {
        thumbs = text.split("\n");

        originals.forEach(original => {
          var thumbExists = false;
          thumbs.forEach(thumb => {
            if(original.replace("originals", "thumbs") == thumb) thumbExists = true;
          });

          if(!thumbExists) missingThumbs.push(original);
        });

        return missingThumbs;
      })
      .then(missingThumbs => {
        //callThumb();
        //thumbInterval = setInterval(callThumb, 30000);
      });*/

    /*if (nextProps.artists) {
      //artistList = nextProps.artists;
      console.log("SHOULD COMPONENT UPDATE");

      let imageNum = 0;
      nextProps.artists.map( (artist, index) => {
        if(artist.hasOwnProperty("images")) {
          let replace = false;

          let images = artist.images.map( image => {
            if(image.original.match(/\.[0-9a-z]{1,4}$/g)[0] != image.thumb.match(/\.[0-9a-z]{1,4}$/g)[0]) {
              replace = true;
              image.thumb = image.thumb.replace(/\.[0-9a-z]{1,4}$/g, image.original.match(/\.[0-9a-z]{1,4}$/g)[0])
            }
            return image;
          });

          if(replace) {
            database.ref('artists').child(artist.id).child("images").set(images).then(() => {
              imageNum += images.length;
              console.log("Total: " + imageNum);
            }).catch(function(error) {
              console.log("Set failed: " + error.message)
            });
          }
        }

      });
    }*/

      /*let artistTotal = 0;

      nextProps.artists.map( artist => {
        artistTotal++;
        if(artist.hasOwnProperty("images")) {
          let images = artist.images.map( image => {
            let re = /[^\.]+/;
            let imagePath = image.fullPath.split('/')[1].match(re);
            console.log(imagePath[0]);
            image.thumb = 'thumbs/' + imagePath[0] + '.jpg';
            return image;
          });
          //console.log(images);
          database.ref('artists').child(artist.id).child("images").set(images);
        }

      });

      //callArtist(currArtist, artistList);

      /*artists.map(artist => {
        agent.Artists.add({
          agency: artist.AGENCY,
          instagram: artist.SOCIAL,
          location: artist.LOCATION,
          mediums: this.mapMediums(artist.MEDIUM),
          name: artist.NAME,
          previous:"",
          website: artist.WORK
        });
      });*/
      //return false;
    //}

    return true;
  }

  render() {
    return null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Utility);



// WEBPACK FOOTER //
// ./src/components/Utility.js